import React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { LEGAL_DOCS } from "@/legal/content";

export const LegalFooter = ({ className, dark = false, compact = false }) => (
  <footer className={cn("border-t text-xs", dark ? "border-white/10 text-white/50" : "border-border text-muted-foreground", className)} data-testid="legal-footer">
    <div className={cn("mx-auto flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between", compact ? "px-4 py-3" : "max-w-[1400px] px-4 sm:px-6 lg:px-8 py-4")}>
      <nav className="flex flex-wrap items-center gap-x-2 gap-y-1" aria-label="Legal">
        {LEGAL_DOCS.map((d, i) => (
          <React.Fragment key={d.slug}>
            {i > 0 && <span aria-hidden className="opacity-50">·</span>}
            <Link to={`/legal/${d.slug}`} className={cn("hover:underline", dark ? "hover:text-white" : "hover:text-foreground")} data-testid={`footer-legal-${d.slug}`}>{d.short}</Link>
          </React.Fragment>
        ))}
      </nav>
      <div>© {new Date().getFullYear()} D20 Invoice AI</div>
    </div>
  </footer>
);
